export const proyects = [
    {
        id:1,
        name:"Hey Apple",
        description:"Pagina web comercial creada para el cliente Hey Apple, diseñado y desarrollado con el proposito de transmitir el proposito y la mentalidad de apple",
        image:"/stack/hey-apple/hey-apple-photo.png",
        link: "https://heyapple.com.ar/",
        github: ""
    },
    {
        id: 2,
        name: "El Ascensor Mkt",
        description: "Descripcion del proyecto 2",
        image: "/stack/el-ascensor/el-ascensor-photo.png",
        link: "https://el-ascensor-mkt.vercel.app/",
        github: ""
    },
    {
        id: 3,
        name: "Creatibox",
        description: "Descripcion del proyecto 2",
        image: "/stack/creatibox/creatibox-photo.png",
        link: "https://creatibox.vercel.app/",
        github: ""
    },
    {
        id:4,
        name:"Telemedicina",
        description:"Descripcion del proyecto 1",
        image:"/stack/telemedicina/telemedicina-photo.png",
        link: "https://telemedicinaa.vercel.app/",
        github: "https://github.com/bauticalvo/telemedicina"
    },
    {
        id:5,
        name:"Idiomasmaster",
        description:"Descripcion del proyecto 2",
        image:"/stack/idiomasmaster/idiomasmaster-photo.png",
        link: "https://idiomasmaster-toqy.onrender.com/",
        github: "https://github.com/NahuelMedina/idiomasMasterFront"
    },
    {
        id:6,
        name:"Plagitune",
        description:"Descripcion del proyecto 3",
        image:"/stack/plagitune/plagitune-photo.png",
        link: "",
        github: ""
    },

]